<template>
    <div class="sm-form-stepper" :class="classes?.wrapper">
      <span
        v-for="num in stepsArray"
        :key="num"
        class="step"
        
        :class="[{ active: activeStep >= num }, classes?.step]"
        @click="$emit('go-step', num)"
      ></span>
    </div>
</template>

<script>
    export default {
        name: 'steps-indicator',
        computed: {
            stepsArray() {
                return Array.from({ length: this.steps }, (_, i) => i + 1);
            }
        },
        props: {
            classes: {
                type: Object,
                default: () => ({})
            },
            activeStep: {
                type: Number,
                required: true
            },
            steps: {
                type: Number,
                required: true
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>